<template>
  <div :class="{'has-logo':showLogo}">
    <logo  :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item  v-for="route in routes" :key="route.name" :item="route" :base-path="route.path"   />
         <div v-if='this.$store.state.app.sidebar.opened'  @click="service"><a  href="javascript:void(0);" class="router-link-active"><li role="menuitem" tabindex="-1" class="el-menu-item submenu-title-noDropdown" style="padding-left: 20px; color: rgb(191, 203, 217); background-color: rgb(42, 45, 52);"><svg  aria-hidden="true" class="svg-icon" ><use  xlink:href="#icon-kefun"></use></svg><span >聯繫客服</span></li></a></div>
        <div v-if='!this.$store.state.app.sidebar.opened' @click="service"><a href="javascript:void(0);" class="router-link-active"><li role="menuitem" tabindex="-1" class="el-menu-item submenu-title-noDropdown" style="padding-left: 20px; color: rgb(191, 203, 217); background-color: rgb(42, 45, 52);"><div class="el-tooltip" aria-describedby="el-tooltip-4249" tabindex="0" style="position: absolute; left: 0px; top: 0px; height: 100%; width: 100%; display: inline-block; box-sizing: border-box; padding: 0px 20px;"><svg  aria-hidden="true" class="svg-icon" data-v-31ea41b3=""><use data-v-c8a70580="" xlink:href="#icon-kefun"></use></svg></div></li></a></div>
        <!-- <a @click="jumpCxc('http://cxc.com.hk/')" href="javascript:void(0);" :class="{'cxc-link-Collapse':!isCollapse,'cxc-link-Open':isCollapse}">
          <img src="../../../assets/cxc-logo.png" alt="" class="cxc-logo">
        </a> -->
      </el-menu>

      <div class="silde-title">
          <span @click="serviceShow" :class="{'silde-Open':isCollapse,'silde-Collapse':!isCollapse}" class="triggerServe">服務條款</span>
          <span :class="{'silde-Open-edition':isCollapse,'silde-Collapse':!isCollapse}" class="edition">V2.0.7</span>
      </div>
    </el-scrollbar>
    <el-dialog
  title="聯繫客服"
  :visible.sync="centerDialogVisible"
     :close-on-click-modal=false
      :close-on-press-escape=false
     :modal-append-to-body=false
      width="40%"
      class="centerDialog  bor-der"
      left
>
  <div class="se-lian">
       <div style="width:60px;height:60px"><svg style="width:50px;height:50px;"  aria-hidden="true" class="svg-icon" ><use  xlink:href="#icon-whatapp"></use></svg></div>
       <div>
          <div style="padding:0 15px;font-size:16px;"> 透過Whatsapp聯繫客服</div>
          <div class="inputDeep"><el-input maxlength="11" :disabled="disaed" @focus="relation" @blur="Phoneblur"  onkeyup="this.value=this.value.replace(/[^\d]/g,'') " onafterpaste="this.value=this.value.replace(/[^\d]/g,'') "  v-model.trim="phone" ></el-input></div>
      </div>

  </div>
  <div v-if="upphone"> <span style="color:#D9001B;">*如需修改，</span>請直接輸入帶區號的電話號碼（852XXXXXXXX）</div>


   <div class="se-bao">
        <div v-if="Admin" class="se-cun" @click="preservation">保存</div>
        <div class="se-qian" @click="contact">前往聯繫</div>
   </div>
</el-dialog>
    <el-dialog
      :title="$t('home.serviceV1')"
      :visible.sync="DialogServe"
      :close-on-click-modal=false
      :close-on-press-escape=false
      :show-close=false
      :modal-append-to-body=false
      width="40%"
      class="Terms-box WideAdaptation"
      center>
      <div class="item-content">
        <pre  v-html="serveInfo"></pre>
      </div>
      <span slot="footer" class="dialog-footer">
          <button class="agree"  @click="IntoServeInfo">我已同意</button>
          <button class="unagree" v-if="Admin" @click="editServe">修改</button>
      </span>
    </el-dialog>
    <el-dialog
        title="修改條款"
        :visible.sync="DialogServeInfo"
        :close-on-click-modal=false
        :close-on-press-escape=false
        :show-close=false
        :modal-append-to-body=false
        width="40%"
        class="Terms-box WideAdaptation"
        center>
        <div class="item-content">
          <el-input
            type="textarea"
            class="serveInfo"
            placeholder="请输入内容"
            v-model="Info"
            show-word-limit
            :autosize="{ maxRows: 21}"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <button class="agree" @click="updateServe">確定</button>
            <button class="unagree"  @click="unAgreeInfo">取消</button>
        </span>
    </el-dialog>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import { getToken,removeToken} from '@/utils/auth-session'
import variables from '@/styles/variables.scss'
import {
  serviceRules,
  consentService,
  cancelService,
  updateService,
  servicePhone,
  UpdatePhone
} from "api/home.js"
export default {
  data() {
    return {
      user:localStorage.getItem('code'),
      token:getToken('admin-token'),
      firstServe:false,
      Admin:false,
      phone:'',
      DialogServe:false,
      DialogServeInfo:false,
      serverID:'',
      serveInfo:'',
      Info:'',
      centerDialogVisible:false,
      upphone:false,
      disaed:true,
    }
  },
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {

      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
      console.log('this.$store.state: ', this.$store.state);
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
    created(){

         if(sessionStorage.getItem('admin')==1){
      this.Admin = true
       if(sessionStorage.getItem("balance")==null){
                   console.log( this.$router.options.routes)
                this.$router.options.routes.splice(17, 1)
         }

    }else{
      this.Admin = false

       if(sessionStorage.getItem("balance")==null){

          this.$router.options.routes.splice(16, 2)
         }else{
             this.$router.options.routes.splice(16, 1)
         }


    }


  },
  methods:{



    //獲取焦點
    relation(){
        this.upphone=true;
    },
    //失去焦點
    Phoneblur(){
       this.upphone=false;
    },
    service(){
   this.centerDialogVisible=true;
     this.resetSetItem('watchStorage','true');
   if(this.Admin==true){
     this.disaed=false;
   }else{
     this.disaed=true
   }
   console.log(this.disaed)
   servicePhone({user:this.user,token:this.token}).then(res=>{
      if(res.code==1){
        this.phone=res.info;

      }
   })
    },
    contact(){
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

                  window.location.href = "https://wa.me/"+this.phone;
                  this.centerDialogVisible=false;
                   this.resetSetItem('watchStorage','false');
                }
                else {
                  window.open("https://api.whatsapp.com/send?phone="+this.phone);
                   this.centerDialogVisible=false;
                    this.resetSetItem('watchStorage','false');

                }
    },
    preservation(){

      if(this.phone=='' || this.phone==null){
           this.$message({
                showClose: true,
                message: 'Whatsapp號碼不可為空',
                type: 'warning'
              });
              return false
      }

        UpdatePhone({user:this.user,token:this.token,admin:'1',tell:this.phone}).then(res=>{
          if(res.code==1){
              this.$notify({
                title: '成功',
                message: 'Whatsapp號碼保存成功！',
                type: 'success',
                duration: 2000
              })
              this.centerDialogVisible=false;
               this.resetSetItem('watchStorage','false');
          }else if(res.code==0){
              this.$message({
                showClose: true,
                message: '参数有误，请稍后再试！',
                type: 'error'
              });
            }
        })
    },
    jumpCxc(url) {
      window.open(url,'_blank');
    },
    serviceShow(){
      this.getService()
    },

    getService(){
      serviceRules({user:this.user,token:this.token}).then(res=>{
        console.log('res-service: ', res);
        this.DialogServe = true
        if(res.code==1 && res.info_id>0){
          console.log('不是第一次')
        }else if(res.code==1 && res.info_id==0){
           console.log('第一次')
        }
        this.serveInfo = res.info
        this.serverID = res.info_id
      })
      .catch(err => {
          console.log(err);
      });
    },
    // 修改服務條款彈框進行修改服務的確認
    updateServe(){
      updateService({user:this.user,token:this.token,info:this.Info}).then(res =>  {
          // console.log('res-updateService: ', res);
            if(res.code==1){
              this.$notify({
                title: '成功',
                message: '更新條款成功！',
                type: 'success',
                duration: 2000
              })
            }else if(res.code==0){
              this.$message({
                showClose: true,
                message: '参数有误，请稍后再试！',
                type: 'error'
              });
            }
            this.DialogServeInfo = false
        })
    },
    // 管理員從服務條款中進入到修改條款頁面
    editServe(){
      this.DialogServe = false
      this.DialogServeInfo = true
      this.Info = this.serveInfo
    },
    // 修改彈框返回服務詳情彈框
    unAgreeInfo(){
      this.DialogServeInfo = false
      this.DialogServe = true
    },
    // 我已同意進入系統
    IntoServeInfo(){
      // console.log('進入系統')
      this.DialogServe = false
    },
  }
}
</script>
<style  scoped>

.inputDeep>>>.el-input__inner {
    border: 0;
    color: #01B075;
    font-size:24px;

  }
  .inputDeep>>>.el-input.is-disabled .el-input__inner{
    background-color: #FFF;
  }
  .se-qian{
    margin-top:20px;
        width: 80px;
    height: 35px;
     line-height: 35px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    color: rgb(255, 255, 255);
    cursor: pointer;
    background-color: rgba(26, 188, 156,1);
    border-width: initial;
    border-style: none;

    border-radius: 3px;
  }
  .se-cun{
    margin-top:20px;
    width: 80px;
    height: 35px;
    margin-right:20px;
    line-height: 35px;
    text-align: center;
    box-sizing: border-box;
    box-shadow: none;
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    cursor: pointer;
    font-style: normal;
    color: rgb(153, 153, 153);
    background: inherit inherit inherit inherit inherit inherit inherit inherit inherit;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(215, 221, 228);
    border-radius: 3px;
  }
  /* 如果你的 el-input type 设置成textarea ，就要用这个了 */
  .inputDeep>>>.el-textarea__inner {
    border: 0;
    resize: none;/* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
  }
.se-bao{
  display: flex;
 margin-top:20px;
  padding: 1px;
  justify-content:flex-end;
  align-items: center;
  height: 60px;
  border-top:1px solid #ebeef5;
}
.se-lian{
  display: flex;

}
  .dialog-footer{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
  }
  .dialog-footer .agree,.dialog-footer .unagree{
    width: 120px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    white-space: nowrap;
    cursor: pointer;
    color: #FFF !important;
    border: none;
    font-size: 16px !important;
  }
  .dialog-footer .agree{
    background-color: #01b075;
    border-color: #01b075;
  }
  .dialog-footer .unagree{
    background-color: rgba(1, 176, 117,0.7);
    border-color: rgba(1, 176, 117,0.7) !important;
  }
  button:focus{outline: 0;}
  .item-content{ width: 100%;}
  .item-content pre{
      white-space: pre-line;
      height: 46vh;
      overflow-y: scroll;
  }
  .item-content .serveInfo{
    white-space: pre-line;
    height: 50vh;
  }
  .item-content pre .el-textarea__inner,.item-content .serveInfo .el-textarea__inner{
    height: 100%;
  }

  .el-dialog__header {
    padding: 15px 20px 15px;
  }
.el-menu{
  position: relative;
}

.silde-title{
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 100px;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.triggerServe{
    display: inline-block;
    width: 70%;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    color: #01b075;
    text-align: center;
    background-color: rgb(42, 45, 52);
    font-family: PingFangSC-Regular, PingFang SC;
    padding-right: 10px;
    text-decoration:underline;
    cursor: pointer;
}
.edition{
    display: inline-block;
    width: 30%;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    color: rgb(191, 203, 217);
    text-align: right;
    background-color: rgb(42, 45, 52);
    font-family: PingFangSC-Regular, PingFang SC;
    padding-right: 10px;
}
.silde-title .silde-Open{
  display: inline-block;
  width: 100% !important;
  height: 28px;
  text-align: right;
  padding-right: 2px;
  font-size: 12px;
}
.silde-title .silde-Open-edition{
  display: inline-block;
  width: 100% !important;
  height: 28px;
  text-align: center;
  padding-right: 0px;
  font-size: 16px;
}
.el-menu .cxc-link-Collapse{
  position: absolute;
  bottom: -160px;
  right: 0;
  width: 100%;
  height: 160px;
  text-align: left;
}
.el-menu .cxc-link-Open{
  position: absolute;
  bottom: -78px;
  right: 0;
  width: 100%;
  height: 78px;
  display: flex !important;
  justify-content: center;
}
.cxc-link-Open .cxc-logo{
  width: 100%;
  height: 100%;
}
.cxc-link-Collapse .cxc-logo{
  width: 70%;
  height: 100%;
}

</style>
